export { WebHeroCollection } from "./web-hero-collection";
